import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ab2d98c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manage-articles" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Manage Articles", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Title"),
    /*#__PURE__*/_createElementVNode("th", null, "Author"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Updated"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "no-articles"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_v_btn, {
        color: "primary",
        onClick: _ctx.createArticle
      }, {
        default: _withCtx(() => [
          _createTextVNode("New Article")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_v_table, null, {
      default: _withCtx(() => [
        _hoisted_4,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: article.id,
              onClick: ($event: any) => (_ctx.editArticle(article)),
              class: "clickable-row"
            }, [
              _createElementVNode("td", null, _toDisplayString(article.title), 1),
              _createElementVNode("td", null, _toDisplayString(article.author), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_v_chip, {
                  color: _ctx.getStatusColor(article.status),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(article.status), 1)
                  ]),
                  _: 2
                }, 1032, ["color"])
              ]),
              _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(article.updatedAt)), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_v_btn, {
                  icon: "mdi-pencil",
                  size: "small",
                  variant: "text",
                  onClick: _withModifiers(($event: any) => (_ctx.editArticle(article)), ["stop"])
                }, null, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  icon: "mdi-delete",
                  size: "small",
                  variant: "text",
                  color: "error",
                  onClick: _withModifiers(($event: any) => (_ctx.deleteArticle(article)), ["stop"])
                }, null, 8, ["onClick"])
              ])
            ], 8, _hoisted_5))
          }), 128))
        ])
      ]),
      _: 1
    }),
    (_ctx.articles.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, " No articles found. Create your first article! "))
      : _createCommentVNode("", true)
  ]))
}